import { loadModal } from '../actions/loadModal';
const { waitForAsyncTextGeneration } = require('../helpers/asyncTextGeneration.cjs');

function createMysteryBoxRequestError(response) {
    const error = new Error(response?.responseJSON?.data?.message || 'Failed to prepare your present.');
    error.status = Number(response?.status || 0);
    error.responseJSON = response?.responseJSON;
    return error;
}

// Use global event delegation to handle dynamically added mystery boxes
jQuery(document).on('click', '.btn-open-mystery-box', function (e) {
    e.preventDefault();
    const $this = jQuery(this);
    if ($this.hasClass('is-loading')) return;

    const sessionId = $this.attr('data-session-id') || $this.closest('.g-chatform').attr('data-session-id');
    const sessionToken = $this.attr('data-session-token') || $this.closest('.g-chatform').attr('data-session-token');
    const messageId = $this.attr('data-message-id');
    let $modal = jQuery('#growtypeChatMysteryBoxModal');

    if (!$modal.length) {
        $this.addClass('is-loading');
        loadModal(growtype_chat_ajax.get_mystery_box_modal_action, null, { modalId: 'growtypeChatMysteryBoxModal' })
            .then(function () {
                $this.removeClass('is-loading');
                $this.trigger('click');
            })
            .catch(function () {
                $this.removeClass('is-loading');
            });
        return;
    }

    // Reset modal to initial state (closed box visible)
    $modal.find('.box-closed').removeClass('d-none');
    $modal.find('.box-open').addClass('d-none');
    $modal.find('.mystery-box-reward-container').addClass('d-none');
    $modal.find('.mystery-box-loading-container').removeClass('d-none');
    $modal.find('.mystery-box-animation-container').removeClass('d-none');
    $modal.find('.mystery-box-visual').removeClass('anim-opened anim-opening');
    
    $modal.modal('show');

    jQuery.ajax({
        url: growtype_chat_ajax.url,
        type: 'post',
        data: {
            action: 'growtype_chat_open_mystery_box',
            session_id: sessionId,
            session_token: sessionToken,
            message_id: messageId,
            nonce: growtype_chat_ajax.nonce
        },
        success: async function (response) {
            try {
                response = await waitForAsyncTextGeneration(response, {
                    requestStatus: (job) => new Promise((resolve, reject) => {
                        jQuery.ajax({
                            url: growtype_chat_ajax.url,
                            type: 'post',
                            timeout: 15000,
                            data: {
                                action: growtype_chat_ajax.generation_job_status_action,
                                job_id: job.id,
                                job_token: job.token,
                                nonce: growtype_chat_ajax.nonce
                            },
                            success: resolve,
                            error: (statusResponse) => reject(createMysteryBoxRequestError(statusResponse))
                        });
                    })
                });
            } catch (error) {
                $modal.modal('hide');
                alert(error.message || 'An error occurred. Please try again.');
                return;
            }

            if (response.success) {
                const reward = response.data;
                $modal.addClass('is-mystery-box-loaded');
                $modal.find('.mystery-box-loading-container').addClass('d-none');
                openMysteryBoxModal($modal, reward);
            } else {
                $modal.modal('hide');
                alert(response.data.message || 'Failed to open mystery box.');
            }
        },
        error: function () {
            $modal.modal('hide');
            alert('An error occurred. Please try again.');
        }
    });
});

export function chatMysteryBox($trigger) {
    // This function is now mostly for backward compatibility or initial calls
    // Since the document event listener handles everything, we don't need to do anything here
}

function openMysteryBoxModal($modal, reward) {
    const $visual = $modal.find('.mystery-box-visual');
    const $closedBox = $visual.find('.box-closed');
    const $openBox = $visual.find('.box-open');
    const $rewardContainer = $modal.find('.mystery-box-reward-container');
    const $rewardContent = $modal.find('.reward-content');
    
    // Trigger opening animation after a short delay
    setTimeout(() => {
        // Animation sequence
        $visual.addClass('anim-opening');
        
        setTimeout(() => {
            $closedBox.addClass('d-none');
            $openBox.removeClass('d-none');
            $visual.removeClass('anim-opening').addClass('anim-opened');
            
            setTimeout(() => {
                renderReward($rewardContent, reward);
                $rewardContainer.removeClass('d-none').hide().fadeIn(500);
                $modal.find('.mystery-box-animation-container').addClass('d-none');
            }, 500);
        }, 800); // Wait for shake/jump animation
    }, 200);
}

function renderReward($container, reward) {
    let html = '';

    if (reward.is_premium_unlock) {
        html += `<div class="premium-unlock-badge" style="background: linear-gradient(45deg, #FFD700, #FFA500); color: #fff; padding: 5px 15px; border-radius: 20px; font-weight: bold; margin-bottom: 15px; display: inline-block; box-shadow: 0 4px 15px rgba(255,215,0,0.4); text-transform: uppercase; font-size: 12px; letter-spacing: 1px;">⭐ Premium Unlock ⭐</div>`;
    }

    if (reward.type === 'image') {
        html += `<img src="${reward.url}" alt="Your Reward" style="max-width: 100%; border-radius: 10px; box-shadow: 0 5px 15px rgba(0,0,0,0.3);">`;
    } else if (reward.type === 'video') {
        html += `<video controls autoplay playsinline style="max-width: 100%; border-radius: 10px; box-shadow: 0 5px 15px rgba(0,0,0,0.3);">
                    <source src="${reward.url}" type="video/mp4">
                    Your browser does not support the video tag.
                </video>`;
    } else if (reward.type === 'audio') {
        html += `<div class="reward-audio-player" style="background: rgba(255,144,0,0.1); padding: 15px; border-radius: 10px;">
                    <p style="margin-bottom: 10px; font-weight: bold;">Listen to your present: 🫦</p>
                    <audio controls autoplay style="width: 100%;">
                        <source src="${reward.url}" type="audio/mpeg">
                        Your browser does not support the audio element.
                    </audio>
                </div>`;
    }
    
    if (reward.prompt) {
        html += `<div class="reward-caption" style="margin-top: 15px; font-style: italic; color: #333;">${reward.prompt}</div>`;
    }

    $container.html(html);
}

// Stop audio/video when modal is closed
jQuery(document).on('hidden.bs.modal', '#growtypeChatMysteryBoxModal', function () {
    const $modal = jQuery(this);
    $modal.find('audio, video').each(function () {
        this.pause();
        this.currentTime = 0;
    });
    $modal.find('.reward-content').empty();
    $modal.find('.mystery-box-loading-container').addClass('d-none');
    $modal.find('.mystery-box-reward-container').addClass('d-none');
    $modal.find('.mystery-box-visual').removeClass('anim-opened anim-opening');
    $modal.find('.box-closed').removeClass('d-none');
    $modal.find('.box-open').addClass('d-none');
    $modal.removeClass('is-mystery-box-loaded');
});

